import FetchFactory from "vuex-fetch-factory";
import { StateInterface } from "./state";
import {
  InvoiceRaw,
  InvoiceModel,
  AccessLogUserModel,
  AccessLogUserRaw,
} from "../models";
import { getInvoicesForCurrentUser, getAccessLogs } from "../api";
import { setInvoicesHandle, setAccessLogsHandle } from "./mutations";

const factory = new FetchFactory<StateInterface, unknown>();

export default {
  fetchInvoices: factory.createBulkFetcher<unknown, InvoiceRaw, InvoiceModel>(
    true,
    setInvoicesHandle,
    getInvoicesForCurrentUser,
    (): InvoiceModel => new InvoiceModel()
  ),
  fetchAccessLogs: factory.createBulkFetcher<
    unknown,
    AccessLogUserRaw,
    AccessLogUserModel
  >(
    true,
    setAccessLogsHandle,
    getAccessLogs,
    (): AccessLogUserModel => new AccessLogUserModel()
  ),
};
